export default __webpack_public_path__ + "static/media/Elite club.45889370.svg";